module.exports = __webpack_public_path__ + "img/google-logo-white.cba30d30.svg";